import { getIcon } from 'assets/img/icons';
import * as S from './MessageStyled';

export const Message = () => {
  return (
    <S.MessageContainer>
      <S.Icon src={getIcon('successo')} alt="Icone de demostração" />
      <S.Title>Transfer order sent</S.Title>
      <S.Text>
        Withdrawal request sent.
        <S.Text>Visit the history to check the status of your order.</S.Text>
      </S.Text>
      <S.Title small>Transfer fee to email@email.com</S.Title>
      <S.Title large>MATCH 500.00 </S.Title>
    </S.MessageContainer>
  );
};
